import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { IValuesCollection } from '../ts/appTheme';

import {
    ISuggestionValue,
    SuggestionSelect,
    convertToSuggestionValues
} from '../../../_common/platform/tsx/SuggestionSelect';

const moment = require('pdc-platform-moment');

export const BROWSER_DEFAULT = 'Browser default';

export interface ITimeZonesListFieldOptions {
    singleSelectMode?: boolean;
    allowNull?: boolean;
    theme?: IValuesCollection;
    glob?: IGlob;

    onChange?(value: string[]): void;
}

export interface ITimeZonesListFieldProperties extends ITimeZonesListFieldOptions {
    value?: string[];
    options?: ITimeZonesListFieldOptions;
}

export default function TimeZonesListField(props: ITimeZonesListFieldProperties) {
    const options = props.options || {};

    const handleOnChange = (values: ISuggestionValue[]) => {
        const onChange = props.onChange || options.onChange;

        if (onChange != null) {
            let result: string[];

            if (values != null) {
                result = values.map((value) => value.value);
            } else {
                result = null;
            }

            onChange(result);
        }
    };

    const timeZones = [BROWSER_DEFAULT].concat(moment.tz.names());
    const displayValues = convertToSuggestionValues(timeZones);

    let singleSelectMode = props.singleSelectMode;

    if (singleSelectMode === undefined) {
        singleSelectMode = options.singleSelectMode;

        if (singleSelectMode === undefined) {
            singleSelectMode = true;
        }
    }

    let allowNull = props.allowNull;

    if (allowNull === undefined) {
        allowNull = options.allowNull;
    }

    return (
        <div className="time-zones-list-field">
            <SuggestionSelect
                value={props.value || [BROWSER_DEFAULT]}
                displayValues={displayValues}
                singleSelectMode={singleSelectMode}
                allowNull={allowNull}
                theme={props.theme || options.theme}
                glob={props.glob || options.glob}
                onChange={handleOnChange}
            />
        </div>
    );
}
